import { render, staticRenderFns } from "./formPrice.vue?vue&type=template&id=1501b040&"
import script from "./formPrice.vue?vue&type=script&lang=js&"
export * from "./formPrice.vue?vue&type=script&lang=js&"
import style0 from "./formPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports